import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { AgentsCacheResolver, ClientResolver, CountriesResolver, LocalesResolver } from 'core/resolvers';
import { DashboardResolver } from './dashboard.resolver';
import { DashboardComponent } from './dashboard/dashboard.component';

const dashboardRoutes: Routes = [
  {
    path: 'dashboard',
    title: 'parentDashboard',
    resolve: {
      countries: CountriesResolver,
      agentsCache: AgentsCacheResolver,
      locales: LocalesResolver,
      client: ClientResolver
    },
    children: [
      {
        path: '',
        title: 'dashboard',
        component: DashboardComponent,
        canActivate: [ProfileGuard],
        data: { action: 'dashboard.home' },
        resolve: { dashboard: DashboardResolver }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(dashboardRoutes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {}
